<template>
  <div class="table-responsive">
    <div v-if="isLoading" class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>

    <div class="list-group">
      <div class="row d-flex justify-content-between list-group-item list-group-item-action" style="background: #212529; color: white; font-weight: bold;">
        <div class="col-1"></div>
        <div class="col-4">
          {{ $t('cms.table.header.title') }}
        </div>
        <div class="col-3">
          {{ $t('cms.table.header.children_count') }}
        </div>
        <div class="col-4">
          {{ $t('cms.table.header.actions') }}
        </div>
      </div>
    </div>

    <div v-if="!resourcesCopy || !resourcesCopy.length">{{ $t('cms.table.no_results') }}</div>

    <div v-if="!isLoading && resourcesCopy" class="list-group">
      <draggable :list="resourcesCopy" @end="onEnd($event)">
        <div v-for="(element, index) in resourcesCopy" :key="element.id" class="row d-flex list-group-item list-group-item-action" :class="{ 'bg-light': index % 2 !== 0 }">
          <div class="col-1">
            <b-icon-grip-vertical class="h3 mb-0" role="button"></b-icon-grip-vertical>
          </div>
          <div class="col-4 d-flex align-items-center">
            {{ element.title }}
          </div>
          <div class="col-3 d-flex align-items-center">
            {{ element.childrenCount }}
          </div>
          <div class="col-4">
            <div class="d-flex align-items-center">
              <b-icon-arrow-up-square-fill
                  class="mr-2"
                  style="cursor: pointer"
                  font-scale="2.2"
                  variant="warning"
                  @click="moveResource('up', element.id)"
              >
              </b-icon-arrow-up-square-fill>
              <b-icon-arrow-down-square-fill
                  class="mr-2"
                  style="cursor: pointer"
                  font-scale="2.2"
                  variant="warning"
                  @click="moveResource('down', element.id)"
              >
              </b-icon-arrow-down-square-fill>
              <router-link class="btn btn-primary btn-sm"
                           :to="{ name: 'cms-general', params: { id: element.id }}"> {{$t('cms.table.btn.edit')}}
              </router-link>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },
  data() {
    return {
      resourcesCopy: []
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.cms.isLoading,
      resources: (state) => state.cms.resourceStructure ? state.cms.resourceStructure[0].children : null
    }),
  },
  watch: {
    resources() {
      this.setResourcesCopy();
    }
  },
  mounted() {
    this.$store.commit('cms/SET_ACTIVE_RESOURCE_PARENT_ID', false);
    this.$store.commit('cms/SET_IS_EDIT_RESOURCE', false);
    this.$store.commit('cms/SET_ACTIVE_RESOURCE_ID', null);
    this.$store.commit('cms/SET_RESOURCE_DETAILS_INITIAL_VALUE');

    this.setResourcesCopy();
  },
  methods: {
    setResourcesCopy() {
      this.resourcesCopy = this.resources ? [...this.resources] : null;
    },
    onEnd(e) {
      const parentId = this.resourcesCopy[e.newIndex-1] ? this.resourcesCopy[e.newIndex-1].id : -1;

      const payload = {
        id: Number(this.resourcesCopy[e.newIndex].id),
        direction: parentId >= 0 ? 'next_of' : 'first',
        nextOf: parentId
      }

      this.$store.dispatch('cms/moveResource', payload).then(() => {
        this.$store.dispatch('cms/getResourceStructure');
      });
    },
    moveResource(direction, id) {
      const payload = {
        id: Number(id),
        direction: direction
      }

      this.$store.dispatch('cms/moveResource', payload).then(() => {
        this.$store.dispatch('cms/getResourceStructure');
      });
    }
  }
}
</script>